import {useEffect} from 'react'
import {useSearchParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetSeedTicketStatus = () => {
	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [searchParams] = useSearchParams()
	const page = searchParams.get('page')
	const search = searchParams.get('search')
	const ticketTypeIdx = searchParams.get('ticketTypeIdx')

	const [, setAlert] = useAlertModalAtom()
	const [userRole] = useRoleCookie()
	useEffect(() => {
		const rolePath = getApiRolePath(userRole)
		let url = `/${rolePath}/record_seed_ticket?page=${page || 1}`

		if (search) url += `&search=${search}`
		if (ticketTypeIdx) url += `&ticketTypeIdx=${ticketTypeIdx}`

		fetchRequest('GET', url)
	}, [page, search, ticketTypeIdx])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 'page')
					setAlert('페이지 번호를 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'search')
					setAlert('검색어를 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
			default:
				if (fetchResult?.statusCode && fetchResult?.statusCode !== 200) {
					setAlert(fetchResult?.data?.message || '오류가 발생했습니다.')
				}
				break
		}
	}, [fetchResult])

	return [fetchResult, isLoading]
}

export default useGetSeedTicketStatus
